// DEPENDENCIES
import React, { useState, useEffect, useRef } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import _ from 'lodash';
import hash from 'hash-it';
// COMPONENTS
import { Link } from 'react-router-dom';
import FormControl from '@material-ui/core/FormControl';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Chip } from '@material-ui/core';
import Alert from 'react-bootstrap/Alert';
// ICONS
import { IoChevronUp, IoChevronDown } from 'react-icons/io5';
import { BiDollar } from 'react-icons/bi';
import { FiEdit3 } from 'react-icons/fi';
import { FaCheck } from 'react-icons/fa'
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import TextHeader from '../../components/TextHeader';
import Button from '../../components/Button';
import BottomSheet from '../../components/BottomSheet';
import InputBlock from '../../components/InputBlock';
import SelectBlock from '../../components/SelectBlock';
import ActionBlock from '../../components/ActionBlock';
import TextAreaBlock from '../../components/TextAreaBlock';
import ContentModal from '../../components/ContentModal';
import ContentHeader from '../../components/ContentHeader';
// SERVICES AND HELPERS
import { Alert as AlertBox } from '../../helpers/Alert';
import * as Helper from '../../helpers/helper';
import * as QuoteService from '../../services/quote.service';
import * as CategoryService from '../../services/category.service';
import * as ProductService from '../../services/product.service';

const QuoteManagePage = (props) => {
    const { location } = props
    const urlId = location.pathname.split('/').pop();
    const [quoteId, setQuoteId] = useState(parseInt(urlId) == urlId ? urlId : 0);
    const initialQuoteState = {
        id: quoteId,
        client: "",
        note: "",
        companyId: 0,
        quoteCategory: [],
        quoteProduct: []
    }

    const [bottomSheetOpen, setBottomSheetOpen] = useState(false);
    const [quote, setQuote] = useState(initialQuoteState);
    const [products, setProducts] = useState([]);
    const [product, setProduct] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [allCategories, setAllCategories] = useState([]);
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState([]);
    const [quoteItems, setQuoteItems] = useState([]);
    const [note, setNote] = useState(quote.note);
    const [bonusData, setBonusData] = useState({ currentTotal: 0, currentTotalBonus: 0, currentRemainingBonus: 0, amountUntilNextBonus: 0, nextBonusAmount: 0 });
    const [showNote, setShowNote] = useState(false);
    const [showCategorySelect, setShowCategorySelect] = useState(false);
    const [showCategorySample, setShowCategorySample] = useState(false);
    const [showProductSample, setShowProductSample] = useState(false);
    const [saving, setSaving] = useState(false);
    const [isMonthsRequired, setIsMonthsRequired] = useState(false);
    const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(-1);
    const body = document.querySelector('body');
    const durationOptions = Helper.GetMonthOptionsForDuration(12) ?? [];
    const [errorMessage, setErrorMessage] = useState([]);

    useEffect(() => {
        QuoteService.Get(quoteId).then(res => {
            setQuote(res);
            if (res.hashId == null) {
                res.hashId = hash(res.id);
                QuoteService.Save(res).then(res => { }).catch(ex => { });
            }
            setNote(res.note);

            LoadQuoteCategories();

            CategoryService.GetAll(res.companyId, false).then(res => {
                setAllCategories(res);
            }).catch(ex => { });
        });
        LoadQuoteItems(quoteId);
        QuoteService.IsMonthsRequired().then((res) => {
            setIsMonthsRequired(res);
        }).catch((ex) => { });
    }, [])

    const LoadQuoteItems = async (quoteId) => {
        return await QuoteService.GetQuoteProducts(quoteId).then(res => {
            setQuoteItems(res);
            QuoteService.GetBonusBuyNumbers(quoteId).then(res => {
                setBonusData(res);
            });
            return res;
        });
    }

    const LoadCategory = (categoryId) => {
        CategoryService.Get(categoryId)
            .then(res => {
                setSelectedCategory(res);
            }).catch(ex => { });
    }

    const LoadCategorySampleModal = (categoryId) => {
        CategoryService.Get(categoryId)
            .then(res => {
                setCategory(res);
                setShowCategorySample(true);
            }).catch(ex => { });
    }

    const LoadProducts = (categoryId) => {
        ProductService.GetAllForCategory(categoryId)
            .then(res => {
                setProducts([]);
                setProducts(res);
            }).catch(ex => { });
    }

    const LoadProductSampleModal = (productId) => {
        ProductService.Get(productId)
            .then(res => {
                console.log(res);
                setProduct(res);
                setShowProductSample(true);
            }).catch(ex => { });
    }

    const LoadQuoteCategories = () => {
        CategoryService.GetSelectedForQuote(quoteId).then(res => {
            setCategories(res);
        }).catch(ex => { });
    }

    const SaveQuoteClient = (client) => {
        QuoteService.SaveClient(quoteId, client).then(res => { }).catch(ex => { });
    }

    const SaveQuoteProduct = (model) => {
        QuoteService.SaveProduct(model).then(res => {
            LoadQuoteItems(quoteId);
        }).catch(ex => { });
    }

    const SetQuoteProductMonths = (model) => {
        QuoteService.SetQuoteProductMonths(model).then(res => { }).catch(ex => { });
        return;
    }

    const SubmitQuote = async () => {
        if (isMonthsRequired) {
            const newQuoteItems = await LoadQuoteItems(quoteId);
            const filteredQuoteItems = newQuoteItems.filter((x) => !x.isBonus);
            const errList = [];

            console.log(newQuoteItems);

            filteredQuoteItems.forEach(item => {
                if (item.quantity !== ((item.months === '' || !item.months) ? 0 : item.months.split(',').length)) {
                    console.log('Item is ', item);
                    errList.push(`${item.product.name} has ${item.quantity} quantity but only ${(item.months === '' || !item.months) ? 0 : item.months.split(',').length} month(s) has been selected `)
                }
            });
            setErrorMessage(errList);
            if (errList.length > 0) {
                AlertBox({ success: false, message: "Error! Please review the error message!" });
                return;
            }
        }

        setSaving(true);
        QuoteService.SubmitQuote(quoteId).then(res => {
            setSaving(false);
            AlertBox({ success: true, message: "Quote has been submitted!" });
            props.history.push("/campaign-summary/" + quote.hashId);
        }).catch(ex => {
            setSaving(false);
        });
    }

    const toggleBottomSheet = () => {
        setBottomSheetOpen(!bottomSheetOpen);
        if (!bottomSheetOpen) {
            disableBodyScroll(body);
        } else {
            enableBodyScroll(body);
        }
    }

    return (
        <>
            <CustomBlock className="main-container white--bg">
                <Section rowClassName="quote-header">
                    <CustomBlock className="client-name">
                        <h4 className="header-subtitle">
                            Client
                        </h4>
                        <CustomBlock>
                            <InputBlock
                                id="client"
                                name="client"
                                placeholder="Enter Client Name"
                                bordered
                                defaultValue={quote.client}
                                onBlur={(e) => {
                                    SaveQuoteClient(e.target.value);
                                }}
                            />
                        </CustomBlock>
                    </CustomBlock>

                    <CustomBlock className="quote-header-actions">
                        <Button
                            text="Submit Campaign"
                            className="success--bg"
                            loading={saving}
                            disalbed={saving}
                            onClick={SubmitQuote}
                        />
                        <Button
                            text="Add Notes"
                            className="info--bg"
                            onClick={() => setShowNote(true)}
                            iconLeft={
                                <FiEdit3 className="button-left-icon" />
                            }
                        />
                    </CustomBlock>
                </Section>

                <Section className="quote-body">
                    <ContentBlock>
                        {errorMessage.length > 0 && (
                            <Alert variant="danger" onClose={() => setErrorMessage([])} dismissible>
                                <Alert.Heading>Error!</Alert.Heading>
                                {
                                    errorMessage.map((err) => (
                                        <p>{err}</p>
                                    ))
                                }
                            </Alert>
                        )}
                    </ContentBlock>
                    <CustomBlock className="button-container--flex">
                        <Button
                            text="Update Selected Categories"
                            className="primary--bg"
                            onClick={() => setShowCategorySelect(true)}
                            size="xs"
                        />
                    </CustomBlock>
                    <ContentBlock className="select-block">
                        <TextHeader
                            title="Select Category"
                            size="sm"
                        />
                        <FormControl variant="outlined">
                            <ContentBlock>
                                {
                                    categories.map((category, index) =>
                                        <Chip
                                            label={category.name}
                                            // color={_.some(quoteItems, x => x.product.categoryId == category.id) ? "primary" : ""}
                                            onClick={() => {
                                                LoadCategory(category.id);
                                                LoadProducts(category.id);
                                                setSelectedCategoryIndex(index);
                                            }}
                                            className={`chip-container-override ${index === selectedCategoryIndex ? "lighter-green--bg success--clr" : "lighter-grey--bg mid-grey--clr"} mb-3`}
                                        />
                                    )
                                }
                            </ContentBlock>
                        </FormControl>
                    </ContentBlock>
                    {
                        selectedCategory &&
                        <>
                            <ContentBlock className="category-details-block">
                                <TextHeader
                                    title="Category Details"
                                    size="sm"
                                />

                                <CustomBlock className="item-info">
                                    <CustomBlock className="item-name">
                                        <p className="description" style={{ whiteSpace: 'pre-line' }}>
                                            {selectedCategory ? selectedCategory.description : ""}
                                        </p>
                                        <CustomBlock className="button-container--flex">
                                            <Button
                                                text="Category Media"
                                                className="primary--bg"
                                                size="xs"
                                                onClick={() => LoadCategorySampleModal(selectedCategory.id)}
                                            />
                                        </CustomBlock>
                                    </CustomBlock>
                                </CustomBlock>
                            </ContentBlock>

                            <CustomBlock className="product-block">
                                <TextHeader
                                    title="All Products"
                                    size="sm"
                                />
                                {
                                    products.filter((x) => x.isActive).map((product, index) =>
                                        <CustomBlock
                                            key={product.id}
                                            className="item-block"
                                        >
                                            <CustomBlock className="item-info">
                                                <CustomBlock className="item-name">
                                                    <p>
                                                        {product.name}
                                                    </p>
                                                    <p className="description" style={{ whiteSpace: 'pre-line' }}>
                                                        {product.description}
                                                    </p>
                                                    <CustomBlock className="button-container--flex">
                                                        <Button
                                                            text="More Information"
                                                            className="light-blue--bg"
                                                            size="xs"
                                                            onClick={() => LoadProductSampleModal(product.id)}
                                                        />
                                                    </CustomBlock>

                                                    <CustomBlock className="item-options">
                                                        <CustomBlock className="quantity-select">
                                                            {
                                                                product.usesFreeInput ?
                                                                    <InputBlock
                                                                        name="quantity"
                                                                        inputLabel="Qty"
                                                                        placeholder="Enter Quantity"
                                                                        bordered
                                                                        defaultValue={_.find(quoteItems, x => x.productId == product.id && !x.isBonus)?.quantity}
                                                                        onBlur={(e) => {
                                                                            SaveQuoteProduct({
                                                                                quoteId: quoteId,
                                                                                productId: product.id,
                                                                                quantity: e.target.value,
                                                                                price: product.price,
                                                                                isBonus: false
                                                                            });
                                                                        }}
                                                                    /> :
                                                                    <SelectBlock
                                                                        inputLabel="Qty"
                                                                        bordered
                                                                        options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(x => Helper.SetOptionModel(x))}
                                                                        defaultValue={Helper.SetOptionModel(_.find(quoteItems, x => x.productId == product.id && !x.isBonus)?.quantity)}
                                                                        onChange={option => {
                                                                            option = option === null ? [] : option;
                                                                            SaveQuoteProduct({
                                                                                quoteId: quoteId,
                                                                                productId: product.id,
                                                                                quantity: option.value,
                                                                                price: product.price,
                                                                                isBonus: false
                                                                            });
                                                                        }}
                                                                    />
                                                            }
                                                        </CustomBlock>

                                                        <CustomBlock className="bonus-select">
                                                            {
                                                                product.usesFreeInput ?
                                                                    <InputBlock
                                                                        name="Bonus"
                                                                        inputLabel="Bonus"
                                                                        placeholder="Enter Bonus Quantity"
                                                                        bordered
                                                                        defaultValue={_.find(quoteItems, x => x.productId == product.id && x.isBonus)?.quantity}
                                                                        onBlur={(e) => {
                                                                            SaveQuoteProduct({
                                                                                quoteId: quoteId,
                                                                                productId: product.id,
                                                                                quantity: e.target.value,
                                                                                price: product.price,
                                                                                isBonus: true
                                                                            });
                                                                        }}
                                                                    /> :
                                                                    <SelectBlock
                                                                        inputLabel="Bonus"
                                                                        bordered
                                                                        options={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(x => Helper.SetOptionModel(x))}
                                                                        defaultValue={Helper.SetOptionModel(_.find(quoteItems, x => x.productId == product.id && x.isBonus)?.quantity)}
                                                                        onChange={option => {
                                                                            option = option === null ? [] : option;
                                                                            SaveQuoteProduct({
                                                                                quoteId: quoteId,
                                                                                productId: product.id,
                                                                                quantity: option.value,
                                                                                price: product.price,
                                                                                isBonus: true
                                                                            });
                                                                        }}
                                                                    />
                                                            }
                                                        </CustomBlock>

                                                        {
                                                            !product.hasServiceDuration &&
                                                            <CustomBlock className="duration-select">
                                                                <SelectBlock
                                                                    inputLabel="Month(s)"
                                                                    bordered
                                                                    isMulti
                                                                    options={durationOptions.map(x => Helper.SetOptionModel(x))}
                                                                    defaultValue={_.split(_.find(quoteItems, x => x.productId == product.id)?.months, ',').map(x => x == "" ? null : Helper.SetOptionModel(x))}
                                                                    onChange={options => {
                                                                        options = options === null ? [] : options;
                                                                        SetQuoteProductMonths({
                                                                            quoteId: quoteId,
                                                                            productId: product.id,
                                                                            months: options.map(x => x.value).join()
                                                                        });
                                                                    }}
                                                                    disabled={_.find(quoteItems, x => x.productId == product.id) == null}
                                                                />
                                                            </CustomBlock>
                                                        }
                                                    </CustomBlock>
                                                </CustomBlock>
                                            </CustomBlock>

                                            <CustomBlock className="item-price">
                                                <p>
                                                    Item Price
                                                </p>
                                                <p>
                                                    ${product.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                                                </p>
                                            </CustomBlock>
                                        </CustomBlock>
                                    )
                                }
                            </CustomBlock>
                        </>
                    }
                </Section>
            </CustomBlock>

            <BottomSheet
                title={`${bottomSheetOpen ? "Purchase" : "Running"} Summary`}
                open={bottomSheetOpen}
                onClick={() => toggleBottomSheet()}
                height="full"
                previewHeight={86}
                closeOnMaskPress
                rounded
                icon={
                    bottomSheetOpen ? <IoChevronDown /> : <IoChevronUp />
                }
                iconContainerClass="chevron"
            >
                <CustomBlock className="content-container">
                    <CustomBlock className="quote-header-summary">
                        <CustomBlock className="quote-header-block">
                            <CustomBlock className="cost-title">
                                <p className="total">Total</p>
                            </CustomBlock>
                            <CustomBlock className="cost-number">
                                <p className="total">${bonusData.currentTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                            </CustomBlock>
                        </CustomBlock>

                        <CustomBlock className="quote-header-block">
                            <CustomBlock className="cost-title">
                                <p className="subtotal">Current Level Bonus</p>
                                <p className="subtotal">Bonus Buy Dollars Remaining</p>
                                <p className="subtotal">Amount Until Next Bonus</p>
                                <p className="subtotal">Next Level Bonus</p>
                            </CustomBlock>
                            <CustomBlock className="cost-number">
                                <p className="subtotal">{bonusData.currentTotalBonus == 0 ? '--' : ('$' + bonusData.currentTotalBonus.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</p>
                                <p className="subtotal">${bonusData.currentRemainingBonus.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                <p className="subtotal">{bonusData.amountUntilNextBonus == 0 ? '--' : ('$' + bonusData.amountUntilNextBonus.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</p>
                                <p className="subtotal">{bonusData.nextBonusAmount == 0 ? '--' : ('$' + bonusData.nextBonusAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</p>
                            </CustomBlock>
                        </CustomBlock>

                    </CustomBlock>

                    <CustomBlock className="quote-summary">
                        <CustomBlock className="item-summary-header">
                            <p className="item-header quantity-header">Qty</p>
                            <p className="item-header price-header">Price</p>
                            <p className="item-header bonus-buy-header">Bonus</p>
                            <p className="item-header item-name-header">Item Name</p>
                            <p className="item-header month-header">Mos.</p>
                            <p className="item-header total-header">Subtotal</p>
                            <p className="item-header action-header">Actions</p>
                        </CustomBlock>
                        {
                            quoteItems.map((item, index) =>
                                <CustomBlock
                                    key={item.id}
                                    className="item-summary-line"
                                >
                                    <p className="quantity">{item.quantity}</p>
                                    <p className="price">${item.product.price.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <p className="bonus-buy">
                                        <p className={item.isBonus ? "bonus-buy-coin--true" : "bonus-buy-coin--false"}>
                                            <BiDollar />
                                        </p>
                                    </p>
                                    <p className="item">{item.product.name}</p>
                                    <p className="month">{item.duration}</p>
                                    <p className="total">${(item.quantity * item.product.price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                    <Link
                                        className="action"
                                        onClick={() => QuoteService.DeleteQuoteProduct(item.id)
                                            .then(res => {
                                                setQuoteItems(_.filter(quoteItems, x => x.id != item.id));
                                                LoadProducts(selectedCategory.id);
                                                LoadQuoteItems(quoteId);
                                            })
                                            .catch(ex => { })}
                                    >
                                        Remove
                                    </Link>
                                </CustomBlock>
                            )
                        }
                    </CustomBlock>
                </CustomBlock>
            </BottomSheet>

            {/* Note Update */}
            <Dialog
                id="note-dialog"
                open={showNote}
                fullWidth="lg"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Quote Note"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <TextAreaBlock
                            id="quoteNote"
                            placeholder="Enter Note"
                            bordered
                            defaultValue={note ? note : ""}
                            onBlur={(e) => setNote(e.target.value)}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <CustomBlock className="content-container--actions" style={{ paddingRight: 20, paddingBottom: 20 }}>
                        <Button
                            text="Close"
                            className="danger--bg"
                            onClick={() => setShowNote(false)}
                        />
                        <Button
                            text="Submit"
                            className="success--bg"
                            loading={saving}
                            disabled={saving}
                            onClick={
                                () => {
                                    setSaving(true);
                                    QuoteService.SaveNote(quoteId, note)
                                        .then(res => {
                                            setSaving(false);
                                            AlertBox({ success: true, message: "Note has been saved!" });
                                            setShowNote(false);
                                        })
                                        .catch(ex => {
                                            setSaving(false);
                                        })
                                }
                            }
                        />
                    </CustomBlock>
                </DialogActions>
            </Dialog>

            {/* Category Selection */}
            <Dialog
                id="category-select-dialog"
                open={showCategorySelect}
                fullScreen
                fullWidth="lg"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <ContentHeader
                        title="Selected Categories"
                        headerSize="md"
                        style={{ marginTop: 20 }}
                    />
                    {
                        <>
                            {
                                allCategories.map((category, index) =>
                                    <ActionBlock
                                        key={category.id}
                                        className="light--bg"
                                        title={category.name}
                                        actionsPosition="right"
                                        primaryActionText="View Sample"
                                        primaryActionBackground="info--bg"
                                        primaryActionOnClick={() => LoadCategorySampleModal(category.id)}
                                        toggleIconPosition="left"
                                        toggleIcon={
                                            <FaCheck size={20} className={_.find(categories, x => x.id == category.id) != undefined ? "success--clr" : "grey--clr"} />
                                        }
                                        toggleIconBackground={_.find(categories, x => x.id == category.id) != undefined ? "lighter-green--bg" : "light--bg"}
                                        toggleIconOnClick={() => {
                                            if (_.find(categories, x => x.id == category.id) != undefined)
                                                _.remove(categories, x => x.id == category.id);
                                            else
                                                categories.push({ id: category.id });
                                        }}
                                    />
                                )
                            }
                        </>
                    }
                </DialogContent>
                <DialogActions style={{ padding: 24 }}>
                    <Button
                        text="Close"
                        className="danger--bg"
                        onClick={() => {
                            LoadQuoteCategories();
                            setShowCategorySelect(false);
                        }}
                    />
                    <Button
                        text="Submit"
                        className="success--bg"
                        loading={saving}
                        disabled={saving}
                        onClick={
                            () => {
                                setSaving(true);
                                QuoteService.Save({ id: quoteId, companyId: quote.companyId, client: quote.client, quoteCategory: _.map(categories, function (category) { return { categoryId: category.id } }) })
                                    .then(res => {
                                        setSaving(false);
                                        LoadQuoteCategories();
                                        setShowCategorySelect(false);
                                        AlertBox({ success: true, message: "Category Selection Updated!" });
                                    })
                                    .catch(ex => {
                                        setSaving(false);
                                        LoadQuoteCategories();
                                        setShowCategorySelect(false);
                                    })
                            }
                        }
                    />
                </DialogActions>
            </Dialog>

            {/* Content Modals */}
            <ContentModal
                show={showCategorySample}
                onHide={() => setShowCategorySample(false)}
                size="xl"
                centered
                contentHeader={category.name}
                contentDescription={category.description}
                primaryVideoHeader="Sample Video"
                primaryVideoUrl={category.videoPath}
                primaryImageHeader="Logo Image"
                primaryImageUrl={category.logoPath}
                secondaryImageHeader="Sample Image"
                secondaryImageUrl={category.imagePath}
            />

            <ContentModal
                show={showProductSample}
                onHide={() => setShowProductSample(false)}
                size="xl"
                centered
                contentHeader={product.name}
                primaryButtonText={`Audience Size: ${product.audienceSize && product.audienceSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                contentDescription={product.description}
                additionalDetailsHeader="Best Used For"
                additionalDetails={product.bestUsedFor}
                primaryVideoHeader="Sample Video"
                primaryVideoUrl={product.sampleVideoPath}
                primaryImageHeader="Primary Sample Image"
                primaryImageUrl={
                    product.productImage
                        ? _.find(product.productImage, x => x.isPrimary)
                            ? _.find(product.productImage, x => x.isPrimary).imagePath
                            : (product.productImage.length > 0
                                ? product.productImage[0].imagePath
                                : "")
                        : ""
                }
                multipleImageListHeader="Sample Images"
                multipleImageList={
                    product.productImage
                        ? _.find(product.productImage, x => x.isPrimary)
                            ? _.filter(product.productImage, x => !x.isPrimary).map(x => x.imagePath)
                            : _.drop(product.productImage).map(x => x.imagePath)
                        : ""
                }
            />
        </>
    );
}

export default QuoteManagePage;